import {AccordionSummary, AccordionDetails, Accordion} from "@mui/material";
import {APP_ROUTES} from "@src/core/constants";
import {RouteType, WorkspaceType} from "@src/core/types";
import {CustomExpandIcon} from "@src/pages/route-management-page/components/route-component/components";
import {
    WorkspaceItemHeader,
    RoutesGroup,
    RouteItem,
    RouteName,
    RouteDescription,
    RouteMethod,
    WorkSpaceName
} from "@src/pages/route-management-page/components/route-component/route-component.styles";
import type {Dispatch, FC, SetStateAction, SyntheticEvent} from "react";
import {memo, useCallback} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {ReactComponent as FolderClose} from "@src/core/icons/folder_close.svg";
import {ReactComponent as FolderOpen} from "@src/core/icons/folder_open.svg";

export interface AccotdionProps {
    index: number;
    spaceIndex: number | undefined;
    setSpaceIndex: Dispatch<SetStateAction<number | undefined>>;
    handleIconClick: (event: SyntheticEvent) => void;
    deleteWorkspace: () => void;
    expanded: boolean;
    handleAccordionChange: any;
    workspace: WorkspaceType;
    setSpaceIdByClick: Dispatch<SetStateAction<string>>;
}

export const CustomAccordion: FC<AccotdionProps> = memo(
    ({
         index,
         spaceIndex,
         setSpaceIndex,
         handleIconClick,
         deleteWorkspace,
         expanded,
         handleAccordionChange,
         workspace,
         setSpaceIdByClick,
     }) => {
        const navigate = useNavigate();
        const {routeId} = useParams();

        const methodUpdate = useCallback(
            (routeId: number, workspaceId: number, workspaceIndex: number) => {
                navigate(
                    `${APP_ROUTES.WORKSPACE}/${workspaceId}${APP_ROUTES.ROUTES}/update/${routeId}`,
                );
                setSpaceIndex(workspaceIndex);
            },
            [navigate, setSpaceIndex],
        );
        const handleContentClick = (event: SyntheticEvent) => {
            event.stopPropagation();
        };
        return (
            <Accordion
                elevation={0}
                expanded={expanded}
                onChange={handleAccordionChange}
                TransitionProps={{
                    unmountOnExit: true,
                }}
                className="accordion"
                defaultExpanded={index === spaceIndex}
                sx={{
                    "&:before": {
                        display: "none",
                    },
                }}
            >
                <AccordionSummary
                    expandIcon={
                        <CustomExpandIcon
                            spaceId={workspace.id}
                            spaceIndex={index}
                            setSpaceIndex={setSpaceIndex}
                            handleIconClick={handleIconClick}
                            deleteWorkspace={deleteWorkspace}
                            setSpaceIdByClick={setSpaceIdByClick}
                            handleAccordionChange={handleAccordionChange}
                        />
                    }
                    aria-controls="panel1a-content"
                >
                    <WorkSpaceName>
                        {expanded ? <FolderOpen/> : <FolderClose/>}
                        <WorkspaceItemHeader>{workspace.name}</WorkspaceItemHeader>
                    </WorkSpaceName> </AccordionSummary>
                {workspace.routes.length !== 0 && (
                    <AccordionDetails onClick={handleContentClick}>
                        {workspace.routes.map((route) => (
                            <RoutesGroup key={route.id}>
                                <RouteItem
                                    onClick={(e) => methodUpdate(route.id, workspace.id, index)}
                                    className={route.id === Number(routeId) ? "active-route" : ""}
                                >
                                    <div>
                                        <RouteName>{route.name}</RouteName>
                                        <RouteDescription>{route.description}</RouteDescription>
                                    </div>
                                    <RouteMethod method={route.method}>
                                        {route.method}
                                    </RouteMethod>
                                </RouteItem>
                            </RoutesGroup>
                        ))}
                    </AccordionDetails>
                )}
            </Accordion>
        );
    },
);
